import React from "react";
import { TextInput } from "components";

const TitleField = ({ value, onChange, label = "Game title", placeholder = "What should we call your game?" }) => (
  <TextInput
    label={label}
    placeholder={placeholder}
    value={value}
    maxLength={60}
    onChange={(e) => onChange(e.target.value)}
  />
);

export default TitleField;
